import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import { ConvoService } from '../../../service/ConvoService'
import { IConvo } from '../../../model/convo'
import convoStore from '../convo-store'
import convoUtils from './convo-utils'
import fetchReferences from './fetch-references'
import { IReference } from '../../../model/reference'

export default async function removeConvoReference(context: BareActionContext<ConvoState, RootState>, payload: { convo: IConvo, reference: IReference })
{
  convoUtils.convoService.removeReference(payload.convo, payload.reference).then((result: any) => {
    fetchReferences(context, payload.convo)
  })

  return
}
